import styled, { css, keyframes } from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.g200};
`

const slides = keyframes`   
   from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`

export const LogoItems = styled.div<{ $count: number }>`
    display: flex;
    align-items: center;
    animation: ${({ $count }) => {
        const duration = $count * 3
        return css`
            ${duration}s ${slides} infinite linear
        `
    }};
`

export const Logos = styled.div`
    overflow: hidden;
    padding: 30px 0px;
    white-space: nowrap;
    display: flex;
    position: relative;

    &:hover {
        ${LogoItems} {
            animation-play-state: paused;
        }
    }
`

export const Image = styled(ImageBase)`
    max-width: 150px;
`

export const ImageWrapper = styled.div`
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${(props) => props.theme.boxShadow.level1};
    background-color: ${(props) => props.theme.color.white};
    border-radius: 8px;
    height: 90px;
    margin: 0 15px;
    width: 120px;
`
